import type { DocMigration } from "../docMigration";

const defaultMirrorOptionSet = {
  id: "mirror",
  sortIndex: 0,
  defaultValue: "false",
  name: "Mirror",
  entityType: "OPTION_SET",
  salesCategory: "UNCATEGORIZED",
  options: {
    true: {
      parentId: "mirror",
      name: "Mirror home",
      sortIndex: 0,
    },
    false: {
      parentId: "mirror",
      name: "Don't mirror home",
      sortIndex: 1,
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_207: DocMigration = {
  maxSchemaVersion: "0.0.207",
  description: "Sets a default value for doc garage-handing and adds a mirror option set if it doesn't exist",
  apply(json: any) {
    if (!json.attributes) {
      json.attributes = {};
    }

    json.attributes = {
      ...json.attributes,
      garageHandingDirection: json.attributes?.garageHandingDirection?.toLowerCase() ?? "left",
    };

    if (!json.optionSets?.mirror || Object.keys(json.optionSets?.mirror ?? {}).length === 0) {
      json.optionSets = {
        ...json.optionSets,
        mirror: defaultMirrorOptionSet,
      };
    }

    return json;
  },
};

export default migration_0_0_207;
